<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="goBack">{{
              $t("message.orderHistory")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="chargesAdminFee"
      class="login-warning"
      role="alert"
      :style="mobileStyles.alertInfoBackGround"
      style="margin: 55px 0 0"
    >
      <span class="pl-2">{{ adminFeeMessage }}</span>
    </div>
    <div :style="styles.pageColor" class="vform position-relative">
      <div class="justify-content-center">
        <div class="col-12 py-4" :style="columnStyles">
          <div
            class="container mt-4 pt-4 px-0"
            :style="containerStyles"
            style="min-height:50vh;position:relative"
          >
            <div v-show="loading" class="load-bg">
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </div>
            <div v-for="(order, index) in pageOrders" :key="index" class="row">
              <div class="col-sm-12 order-items" :disabled="IsStoreClose">
                <div class="order-item-details">
                  <div class="col-md-12">
                    <div class="row">
                      <h3 class="col-md-9 store-name" style="cursor: pointer">
                        {{ order.StoreName }}
                      </h3>
                      <ul>
                        <li
                          v-for="orderItem in order.OrderItems"
                          :key="orderItem.UDID"
                        >
                          {{ orderItem.Quantity }} x {{ orderItem.Name }}
                        </li>
                      </ul>
                      <span class="order-price">
                        <span
                          >{{ $t("message.total") }}:
                          {{
                            (order.TotalExcludingTax + order.TotalTax)
                              | formatMoney(currencySign)
                          }}</span
                        >
                        <span class="ml-3"
                          >{{ taxLabel }}:
                          {{ order.TotalTax | formatMoney(currencySign) }}</span
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="order-item-cost">
                  <div>
                    <button
                      v-if="enableCancellation(order)"
                      type="button"
                      class="btn btn-primary"
                      :style="mobileStyles.btn"
                      @click="showCancelConfirmDialog(order)"
                    >
                      {{ $t("message.requestToCancel") }}
                    </button>
                    <button
                      type="button"
                      v-if="order.StoreID === currentStoreDoc.ID"
                      class="btn btn-primary mt-1"
                      :style="mobileStyles.btn"
                      @click="showReorderConfirm(order)"
                    >
                      {{ $t("message.reorder") }}
                    </button>
                    <span class="pl-2"
                      >{{ order.OrderNumber ? "#" : ""
                      }}{{ order.OrderNumber }}</span
                    >
                    <div class="history-date">{{ getCreateDate(order) }}</div>
                  </div>
                </div>
              </div>

              <div
                class="cancelrequested col-sm-12"
                v-if="order.OnlineOrderStatus == 12"
              >
                <h3>{{ $t("message.orderCancelRequest") }}</h3>
                <p class="text-danger">
                  {{ order.OnlineOrderStatusDescription }}
                </p>
              </div>
              <div
                class="cancelrequested col-sm-12"
                v-if="order.OnlineOrderStatus == 3"
              >
                <h3>{{ $t("message.orderFaild") }}</h3>
                <p class="text-danger">
                  {{ order.OnlineOrderStatusDescription }}
                </p>
              </div>
              <div
                class="cancelrequested col-sm-12"
                v-else-if="order.OnlineOrderStatus == 10"
              >
                <h3>{{ $t("message.refunded") }}</h3>
                <p class="text-danger">
                  {{ order.OnlineOrderStatusDescription }}
                </p>
              </div>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
            <div v-if="pageOrders.length == 0 && !loading">
              <message :message="getNoOrderAvailable" />
            </div>
          </div>
          <div class="text-center">
            <button
              v-if="orders.length != pageOrders.length"
              class="btn btn-info"
              :style="mobileStyles.btn"
              @click="moreCallback()"
            >
              {{ $t("message.more") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-if="showConfirm"
      ref="reorderConfirm"
      :confirm-title="$t('message.reorder')"
      :proccessing="progressing"
      @confirmed="reorder"
      @close="closeConfirm"
    >
      <template slot="body">
        <p class="mx-3">{{ $t("message.reorderCurrentOrder") }}</p>
      </template>
    </confirm>
    <confirm
      v-if="showCancelConfirm"
      ref="cancelConfirm"
      :proccessing="progressing"
      :confirm-title="$t('message.requestToCancel')"
      @confirmed="cancelOrder"
      @close="closeCancelConfirm"
    >
      <template slot="body">
        <p class="mx-3">{{ $t("message.cancelCurrentOrder") }} ?</p>
      </template>
    </confirm>
    <div v-if="showmeesage" class="m-6 centered">
      <div
        class="error shadow-md p-6 pr-10"
        style="min-width: 240px; text-align: center"
      >
        <p class="messagetext">
          {{ $t("message.CancellationNotPermited") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/OrderHistory.js";
import common from "../../sharedscripts/Common/commonMobile";
import Message from "./../shared/Message";
import confirm from "../confirm.vue";
export default {
  components: {
    Message,
    confirm,
  },

  data() {
    return {
      page: 2,
      perPage: 6,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev",
        },
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      showConfirm: false,
      showCancelConfirm: false,
      progressing: false,
      selectedOrder: {},
      showmeesage: false,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "currentstore",
      "mobileStyles",
      "currentStoreDoc",
      "styles",
    ]),
    ...shared.computed,
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    columnStyles() {
      return this.chargesAdminFee ? "padding-top: 0 !important" : "";
    },
    containerStyles() {
      return this.chargesAdminFee
        ? "margin-top: 0 !important; padding-top: 1rem !important"
        : "";
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    },
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    ...common.methods,
    ...shared.methods,
  },
};
</script>

<style lang="scss" scoped>
.cancelrequested {
  text-align: center;
  padding-left: 15px;
  margin-top: 10px;

  p {
    margin: 0;
  }
}
.required-logo {
  color: red;
}
.centered {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}
</style>
